import * as api from '../api';

export const GET_PROJECT_BUDGETS = 'GET_PROJECT_BUDGETS';
export const GET_PROJECT_BUDGET = 'GET_PROJECT_BUDGET';
export const CREATE_PROJECT_BUDGET = 'CREATE_PROJECT_BUDGET';
export const UPDATE_PROJECT_BUDGET = 'UPDATE_PROJECT_BUDGET';
export const DELETE_PROJECT_BUDGET = 'DELETE_PROJECT_BUDGET';

export const getProjectBudgets = (searchQuery, page, pageSize) => async (dispatch) => {
  try {
    const { data } = await api.fetchProjectBudgets(searchQuery, page, pageSize);
    dispatch({ type: GET_PROJECT_BUDGETS, payload: data });
    return data;
  } catch (error) { console.error('Error fetching project budgets:', error); throw error; }
};

export const createProjectBudget = (budgetData) => async (dispatch) => {
  try {
    const { data } = await api.createProjectBudget(budgetData);
    dispatch({ type: CREATE_PROJECT_BUDGET, payload: data });
    return data;
  } catch (error) { console.error('Error creating project budget:', error); throw error; }
};

export const updateProjectBudget = (id, budgetData) => async (dispatch) => {
  try {
    const { data } = await api.updateProjectBudget(id, budgetData);
    dispatch({ type: UPDATE_PROJECT_BUDGET, payload: data });
    return data;
  } catch (error) { console.error('Error updating project budget:', error); throw error; }
};

export const deleteProjectBudget = (id) => async (dispatch) => {
  try {
    await api.deleteProjectBudget(id);
    dispatch({ type: DELETE_PROJECT_BUDGET, payload: id });
  } catch (error) { console.error('Error deleting project budget:', error); throw error; }
};
